export interface ConnectorPoint {
  x: number;
  y: number;
}

export interface ArrowHeadGeometry {
  tip: ConnectorPoint;
  left: ConnectorPoint;
  right: ConnectorPoint;
}

export function quadraticPoint(start: ConnectorPoint, control: ConnectorPoint, end: ConnectorPoint, t: number): ConnectorPoint {
  const clamped = Math.max(0, Math.min(1, t));
  const inverse = 1 - clamped;
  return {
    x: inverse * inverse * start.x + 2 * inverse * clamped * control.x + clamped * clamped * end.x,
    y: inverse * inverse * start.y + 2 * inverse * clamped * control.y + clamped * clamped * end.y
  };
}

/** Returns the quadratic control point that makes the curve pass through `point` at t = 0.5. */
export function quadraticControlThroughMidpoint(start: ConnectorPoint, point: ConnectorPoint, end: ConnectorPoint): ConnectorPoint {
  return {
    x: 2 * point.x - (start.x + end.x) / 2,
    y: 2 * point.y - (start.y + end.y) / 2
  };
}

export function arrowHeadGeometry(tip: ConnectorPoint, vector: ConnectorPoint, length: number): ArrowHeadGeometry {
  const fallback = Math.abs(vector.x) + Math.abs(vector.y) < 0.0001 ? { x: 1, y: 0 } : vector;
  const angle = Math.atan2(fallback.y, fallback.x);
  return {
    tip,
    left: {
      x: tip.x - Math.cos(angle - Math.PI / 6) * length,
      y: tip.y - Math.sin(angle - Math.PI / 6) * length
    },
    right: {
      x: tip.x - Math.cos(angle + Math.PI / 6) * length,
      y: tip.y - Math.sin(angle + Math.PI / 6) * length
    }
  };
}
